import { makeNewInspectionHref, startNewInspection } from '@/services/inspections/inspectionsService';
import { h } from 'vue';
import { Button } from '@/ui/components/Button';
import { tooltip } from '@/ui/components/Tooltip';
import { t } from '@/ui/i18n/i18n';

interface ChecklistBase {
  id: number;
}

export const startInspection = (checklist: ChecklistBase, hasInspectionQuotaLeft: boolean) => {
  const href = makeNewInspectionHref(checklist.id);

  return tooltip({
    label: t('inspections.fill-out-form'),
    position: 'is-top',
  }, [
    h(Button, {
      class: 'checklist-index-page__action-button',
      props: {
        type: 'is-light',
        tag: 'a',
      },
      on: {
        click: (e: MouseEvent) => {
          startNewInspection(checklist.id, e);
        },
      },
      attrs: {
        id: 'start-inspection',
        iconRight: 'play',
        iconPack: 'far',
        disabled: !hasInspectionQuotaLeft,
        href,
      },
    }),
  ], 'label');
};
